import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const LoginWidget: WidgetRegistryEntry = {
  name: "Login",
  configuration: () => import("./configuration").then((m) => m.LoginWidgetConfiguration),
  component: () => import("./login-widget.component").then((m) => m.LoginWidgetComponent)
};
